import React from "react"
import { Link } from "gatsby"
import { useTranslation, useI18next } from "@zestia/gatsby-plugin-react-i18next"
import PlanFrequencyToggle from "@/components/PlanFrequencyToggle"
import Cookies from "js-cookie"
import { ENGAGED_DISCOUNT_CODE } from "@/utils/discount-tracker"
import { gtmTracking } from "@/utils/gtm-tracking"
import TypeformQuiz from "@/components/TypeformQuiz"

const SignupHeader = ({
  title,
  description,
  snapshot = false,
  onTogglePlanFrequency,
  onTypeformEndingButtonClicked,
  children,
  textClass = "",
  compareAllPlans = true,
}) => {
  const { t } = useTranslation()
  const { language } = useI18next()

  return (
    <div className={`${snapshot ? "" : "md:pt-12 md:pb-12"} `}>
      <div
        className={`container-fluid row signup-header ${snapshot ? "signup-header--snapshot" : ""}`}
      >
        {snapshot ? (
          <>
            <h2 className="mb-4 col-xs-12">
              {title || t("signup.header.title-snapshot")}
            </h2>
            <p className={`col-xs-12 p--lg mb-4  ${textClass || "col-md-7"}`}>
              {description || t("signup.header.description-snapshot")}
            </p>
            <div className="col-xs-12 mb-10">
              {compareAllPlans && (
                <Link
                  to="/signup/"
                  className="text-link signup-header__link"
                  onClick={() =>
                    gtmTracking(
                      "CTA Click",
                      "Compare All Plans",
                      "Pricing Snapshot",
                    )()
                  }
                >
                  {t("signup.header.compare-all-plans")}
                </Link>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="signup-header__title">
              <h1 className="mb-0 h2 mr-0 sm:mr-8 text-balance">
                {snapshot
                  ? t("signup.header.title-snapshot")
                  : t("signup.header.title")}
              </h1>
              {Cookies.get("exp_offer") === ENGAGED_DISCOUNT_CODE ? (
                <p>
                  <span className="signup-header__discount-notice">
                    {t("signup.header.discount-notice")}
                  </span>{" "}
                  {t("signup.header.discount-notice-2")}
                </p>
              ) : (
                <p className="mt-2 signup-header__subtitle">
                  <span>
                    {t("signup.header.not-sure-which-plan-fits-your-needs")}
                  </span>
                  {language === "en" && (
                    <>
                      <span className="signup-header__subtitle-quiz signup_base">
                        <TypeformQuiz
                          triggerButtonClassName="btn--typeform-hyperlink text-link text-link--inline-flex"
                          selectedQuizId="OLeS1CS1"
                          title={t("plans.quiz-title")}
                          popup={true}
                          onEndingButtonClicked={onTypeformEndingButtonClicked}
                        />
                      </span>
                    </>
                  )}
                </p>
              )}
            </div>

            <PlanFrequencyToggle
              onChange={onTogglePlanFrequency}
              snapshot={snapshot}
            />
          </>
        )}
        <div className="col-xs-12">{children}</div>
      </div>
    </div>
  )
}

export default SignupHeader
